exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-regione[data-v-361444d0]{position:fixed;width:15%;z-index:9;right:20px;bottom:20px}@media (max-width:550px){.popup-regione[data-v-361444d0]{width:55%;right:20px;bottom:25%}}.popup-regione .chiudi[data-v-361444d0]{cursor:pointer;position:absolute;right:5px;top:0;z-index:10;color:#000}", ""]);

// exports
